export default __webpack_public_path__ + "static/media/fungal-tinea-Infection.65fdd6a8.JPG";